/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AllowedCurrenciesQueryVariables = GraphQL.Exact<{
  accountId: GraphQL.Scalars['AccountId']['input'];
}>;


export type AllowedCurrenciesQuery = { readonly __typename?: 'Query', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId, readonly allowedCurrencies: ReadonlyArray<GraphQL.Currency> } | null };


export const AllowedCurrenciesDocument = gql`
    query AllowedCurrencies($accountId: AccountId!) {
  account(id: $accountId) {
    id
    allowedCurrencies
  }
}
    `;

/**
 * __useAllowedCurrenciesQuery__
 *
 * To run a query within a React component, call `useAllowedCurrenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllowedCurrenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllowedCurrenciesQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAllowedCurrenciesQuery(baseOptions: Apollo.QueryHookOptions<AllowedCurrenciesQuery, AllowedCurrenciesQueryVariables> & ({ variables: AllowedCurrenciesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllowedCurrenciesQuery, AllowedCurrenciesQueryVariables>(AllowedCurrenciesDocument, options);
      }
export function useAllowedCurrenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllowedCurrenciesQuery, AllowedCurrenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllowedCurrenciesQuery, AllowedCurrenciesQueryVariables>(AllowedCurrenciesDocument, options);
        }
export function useAllowedCurrenciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllowedCurrenciesQuery, AllowedCurrenciesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllowedCurrenciesQuery, AllowedCurrenciesQueryVariables>(AllowedCurrenciesDocument, options);
        }
export type AllowedCurrenciesQueryHookResult = ReturnType<typeof useAllowedCurrenciesQuery>;
export type AllowedCurrenciesLazyQueryHookResult = ReturnType<typeof useAllowedCurrenciesLazyQuery>;
export type AllowedCurrenciesSuspenseQueryHookResult = ReturnType<typeof useAllowedCurrenciesSuspenseQuery>;
export type AllowedCurrenciesQueryResult = Apollo.QueryResult<AllowedCurrenciesQuery, AllowedCurrenciesQueryVariables>;